var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedInactiveMobileNavbar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_2517_12307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.1662 10.1607L15.9443 5.32141C15.3983 4.89664 14.7263 4.66602 14.0345 4.66602C13.3427 4.66602 12.6707 4.89664 12.1247 5.32141L5.90167 10.1607C5.52769 10.4516 5.22511 10.824 5.01705 11.2497C4.80899 11.6753 4.70095 12.1428 4.70117 12.6166V21.0166C4.70117 21.6354 4.947 22.2289 5.38459 22.6665C5.82217 23.1041 6.41567 23.3499 7.03451 23.3499H21.0345C21.6533 23.3499 22.2468 23.1041 22.6844 22.6665C23.122 22.2289 23.3678 21.6354 23.3678 21.0166V12.6166C23.3678 11.6564 22.9245 10.7499 22.1662 10.1607Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.6673 17.5C16.089 19.0552 11.91 19.0552 9.33398 17.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2517_12307"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedInactiveMobileNavbar);
export default __webpack_public_path__ + "static/media/feed-inactive-mobile-navbar.d5b4722deecf3ccc3d593a1c873dcc36.svg";
export { ForwardRef as ReactComponent };